let steps = [
    // STEP 1 — Postal Code
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__postal_code__",
        fields: [
            {
                name: "postal_code",
                placeholder: 'A9A9A9',
                type: "text",
                value: null,
                validationRules: "required|postal",
                fieldOuterClass: "col-md-8 offset-md-2",
                hideIfHasValue: true,
                attrs: { maxlength: 7 },
            },
        ],
    },
    // STEP 2 — Contact & Company Info
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: "__address_city__",
                name: "city",
                type: "text",
                value: null,
                validationRules: "required",
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: true,
                attrs: { maxlength: 50 },
            },
            {
                label: "__province__",
                name: "state",
                type: "select",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: true,
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
            {
                label: '__company_name__',
                name: 'company_name',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 100
                },
            },
            {
                label: '__industry__',
                name: 'business_type',
                placeholder: '__select__',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"RETAIL", "text":"__opt_business_type_pos_retail__"},
                    {"value":"HOME_IMPROVEMENT", "text":"__opt_business_type_pos_home_improvement__"},
                    {"value":"POWERSPORTS", "text":"__opt_business_type_pos_powersports__"},
                    {"value":"AUTOMOTIVE", "text":"__opt_business_type_pos_automotive__"},
                    {"value":"HEALTHCARE", "text":"__opt_business_type_pos_healthcare__"},
                    {"value":"OTHER", "text":"__opt_business_type_other__"},
                ],
                hideIfHasValue: false,
            },
        ],
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
];

export default steps;
